// backoffice/src/services/axiosServicesVisit.js
// Ce fichier est maintenant utilisé pour les modules Visites ET Planning.
// Il utilise localStorage pour le token et construit la baseURL avec le préfixe /api.

import axios from "axios";
import { getToken } from "./authenticationService"; // Assure-toi que ce chemin est correct

// --- Début des Modifications ---

// 1. Lire l'URL de base depuis le fichier .env (doit être SANS /api à la fin)
//    Exemple: REACT_APP_API_URL=http://localhost:4000 dans votre .env
const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// 2. Définir le préfixe API correct utilisé par NestJS (normalement /api)
const API_PREFIX = 'api'; // Assurez-vous que c'est bien '/api' et non '/api/v1'

// 3. Construire l'URL de base finale en ajoutant le préfixe
//    Supprime un éventuel / à la fin de BASE_API_URL
//    Supprime un éventuel / au début de API_PREFIX
//    Concatène les deux avec un seul / entre eux. Résultat attendu: http://localhost:4000/api
const finalBaseURL = `${BASE_API_URL.replace(/\/$/, '')}/${API_PREFIX.replace(/^\//, '')}`;

// 4. Crée l'instance Axios avec la baseURL CORRECTE
const axiosInstance = axios.create({
  baseURL: finalBaseURL, // Doit être http://localhost:4000/api
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- Fin des Modifications ---


// Applique l'intercepteur pour ajouter le token depuis localStorage
// (Logique existante conservée)
axiosInstance.interceptors.request.use(
  async function (config) { // Garder async par cohérence ou si getToken devient async un jour
    try {
      const token = await getToken(); // ou juste getToken() si toujours synchrone
      if (token) {
         config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // Log plus spécifique pour cette instance
      console.error("axiosInstance (Visit/Planning): Failed to add authorization header", error);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse (Logique existante conservée)
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Log plus spécifique
      console.error("axiosInstance (Visit/Planning): Unauthorized! Logging out...");
      // Logique de déconnexion si nécessaire...
    }
    return Promise.reject(error);
  }
);

// Exporte l'instance configurée qui sera utilisée par plusieurs services
export default axiosInstance;